export const educationData = [
    {
        id: 1,
        course: 'Doctorat en Médecine',
    },
    {
        id: 2,
        course: 'Compétence en Maladie Professionnelle et Master Spécialisé en Médecine du Travail',
    },
    {
        id: 3,
        course: "Certificat de fin d'études en homéopathie",
    },
    {
        id: 4,
        course: "Certificat de fin d'études en homéopathie",
    },
    {
        id: 5,
        course: "Compétence et Master Spécialisé et Acupuncture",
    },
    {
        id: 6,
        course: "Certificat d'études supérieures en gériatrie et gérontologie",
    },
    {
        id: 7,
        course: "Certificat en Mésothérapie et en Médecine Esthétique",
    },
]